import { jsx as _jsx } from "react/jsx-runtime";
import { usePageContext } from 'src/hooks/usePageContext';
import { getExperimentArm } from 'src/utils/experiments';
import { ThankYouPageConfirm } from './ThankYouPageConfirm';
import { ThankYouPageVerify } from './ThankYouPageVerify';
/**
 * Thank you page router.
 * Routes to the appropriate TYP variant based on the MFA challenge weblab:
 *
 * - Weblab T1: ThankYouPageVerify — calls verifyOrder to confirm payment authentication
 * - Weblab C:  ThankYouPageConfirm — calls confirmOrder (existing behavior)
 *
 * TODO: When HANDSHAKE_PAINTER_VERIFY_ORDER_TYP graduates, remove this router and ThankYouPageConfirm,
 * then rename ThankYouPageVerify to ThankYouPage.
 */
export const ThankYouPage = () => {
    var _a;
    const { appData } = usePageContext();
    const isVerifyOrderEnabled = getExperimentArm((_a = appData === null || appData === void 0 ? void 0 : appData.data) === null || _a === void 0 ? void 0 : _a.experiments, 'HANDSHAKE_PAINTER_VERIFY_ORDER_TYP') === 'T1';
    return isVerifyOrderEnabled ? _jsx(ThankYouPageVerify, {}) : _jsx(ThankYouPageConfirm, {});
};
